import React from 'react';
import logo from '../assets/logo.png';
import { PageType } from '../App';

interface FooterProps {
  setCurrentPage: (page: PageType) => void;
}

const Footer: React.FC<FooterProps> = ({ setCurrentPage }) => {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <div className="logo-area">
            <img src={logo} alt="Market Entry Logo" className="nav-logo-img" />
            <span>Market Entry</span>
          </div>
          <p>Make smarter expansion decisions before you commit.</p>
        </div>
        <div className="footer-col">
          <h4>Use cases</h4>
          <a onClick={() => setCurrentPage('founder')}>Entrepreneur / Founder</a>
          <a onClick={() => setCurrentPage('executive')}>CEO / CFO</a>
          <a onClick={() => setCurrentPage('investor')}>VC / PE Investment Manager</a>
          <a onClick={() => setCurrentPage('comparison')}>Market comparison</a>
        </div>
        <div className="footer-col">
          <h4>Quick links</h4>
          <a onClick={() => setCurrentPage('about')}>About Us</a>
          <a onClick={() => setCurrentPage('contact')}>Contact Us</a>
          <a onClick={() => setCurrentPage('home')}>Privacy Policy</a>
          <a onClick={() => setCurrentPage('home')}>Terms of Service</a>
        </div>
        <div className="footer-col">
          <h4>Contact</h4>
          <a href="mailto:hello@marketentry.com">hello@marketentry.com</a>
          <a href="tel:+5511976963091">+55 11 97 696 30 91</a>
        </div>
      </div>
      <div className="footer-bottom">
        <span>2026 Nurtify AI LTDA. All rights reserved.</span>
        <div>
          <a onClick={() => setCurrentPage('home')}>Privacy Policy</a>
          <a onClick={() => setCurrentPage('home')}>Terms of Service</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
